import { IconButton } from '@material-ui/core';
import { useState, useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import styles from '../ScreenShareLayout/styles';
import useSignal from 'hooks/useSignal';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import DashboardIcon from '@material-ui/icons/Dashboard';
import Typography from '@material-ui/core/Typography';
import { SET_LAYOUT_TYPE } from 'store/VideoRoom/videoRoomAction';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import { useDispatch, useSelector } from 'react-redux';
const ITEM_HEIGHT = 48;

export default function RecordingLayoutButton({ classes, room }) {
  const localClasses = styles();
  const [layOut, setLayOut] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { sendSignal } = useSignal({ room });
  const dispatch = useDispatch();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLayOutChange = (layout) => {
    handleChangeLayout(layout);
    sessionStorage.setItem('screenshareLayout', layout);
    setLayOut(layout);
    setAnchorEl(null);
  };
  function handleCallback(error) {
    if (error) {
      console.log('error: ' + error.message);
    } else {
      console.log('callback success');
    }
  }
  const handleChangeLayout = (layout) => {
    fetch(
      `${
        process.env.REACT_APP_API_URL
      }/v2/livemeeting/recordingLayout/${sessionStorage.getItem(
        'archiveId'
      )}/${layout}`,
      {
        method: 'POST',
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        console.log(res);
      })
      .catch(handleCallback);
  };
  return (
    <div>
      <Tooltip title='Change Layout'>
        <IconButton
          aria-label='more'
          aria-controls='long-menu'
          aria-haspopup='true'
          className={classes.toolbarButtons}
          onClick={handleClick}
        >
          <ViewModuleIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id='long-menu'
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '40ch',
          },
        }}
      >
        <MenuItem
          className={layOut === '' ? localClasses.choosen : null}
          onClick={() => handleLayOutChange('')}
        >
          <Typography variant='inherit'>Select Layout</Typography>
        </MenuItem>
        <MenuItem
          className={layOut === 'bestFit' ? localClasses.choosen : null}
          onClick={() => handleLayOutChange('bestFit')}
        >
          <Typography variant='inherit'>Best Fit</Typography>
        </MenuItem>
        <MenuItem
          className={
            layOut === 'verticalPresentation' ? localClasses.choosen : null
          }
          onClick={() => handleLayOutChange('verticalPresentation')}
        >
          <Typography variant='inherit'>
            Vertical Speakers with Screenshare
          </Typography>
        </MenuItem>
        <MenuItem
          className={layOut === 'pip' ? localClasses.choosen : null}
          onClick={() => handleLayOutChange('pip')}
        >
          <Typography variant='inherit'>Picture In Picture</Typography>
        </MenuItem>
        {/* <MenuItem
          className={layOut === 'custom' ? localClasses.choosen : null}
          onClick={() => handleLayOutChange('custom')}
        >
          <Typography variant='inherit'>30:70</Typography>
        </MenuItem> */}
      </Menu>
    </div>
  );
}
